import { ChatApp } from "./ChatApp.jsx";

function ChatAppPage() {
  return <ChatApp />;
}

export { ChatAppPage };
